import React, { useEffect } from 'react';

import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { getIntegrations } from './__queries__';
import * as actions from '../../actions';
import { useDispatch, useSelector } from '../../Hooks';

const GET_INTEGRATIONS = gql`
  query getIntegrations($companyId: ID) {
    getIntegrations(companyId: $companyId) {
      success
      integrations
      message
    }

    getIntegrationFields {
      success
      message
      error
      fields {
        formId
        model
        type
        venueId
        companyId
        provider
        values {
          fieldId
          value
        }
      }
    }
  }
`;

const IntegrationsDispatcher: React.FunctionComponent = () => {
  const companyId = useSelector((state) => state.company);
  const authToken = useSelector((state) => state.authToken);
  const dispatch = useDispatch();

  const { loading, error, data, refetch } = useQuery<getIntegrations>(GET_INTEGRATIONS, {
    variables: { companyId },
    fetchPolicy: 'network-only',
  });

  /**
   * If a super admin logs in to a subuser, make sure to refetch
   */
  useEffect(() => {
    refetch();
  }, [authToken]);

  useEffect(() => {
    if (loading || error || !data) {
      return;
    }

    if (!data.getIntegrations.success) {
      console.error('Failed fetching integrations');
      return;
    }

    dispatch(actions.setIntegrations(data.getIntegrations.integrations));

    if (!data.getIntegrationFields.success) {
      console.error(data.getIntegrationFields.message);
      return;
    }

    dispatch(actions.setIntegrationFields(data.getIntegrationFields.fields));
  }, [data]);

  return null;
};

export default IntegrationsDispatcher;
